<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="maintains"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editMaintain.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="售后单号">
            <el-input v-model.trim="filter.billNo" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.details" style="width: 100%;margin: 0 auto">
            <el-table-column prop="materialNo" width="160" align="center" label="物料编号"/>
            <el-table-column prop="materialName" width="200" align="center" label="物料名称"/>
            <el-table-column prop="materialType" width="150" align="center" label="产品分类"/>
            <el-table-column prop="originalProgramNo" width="130" align="center" label="原程序号"/>
            <el-table-column prop="newProgramNo" width="130" align="center" label="新程序号"/>
            <el-table-column prop="serialNumber" width="130" align="center" label="变频器序列号"/>
            <el-table-column prop="quantity" width="100" align="center" label="数量"/>
            <el-table-column prop="unit" width="100" align="center" label="单位"/>
            <el-table-column prop="siteDesc" align="center" label="现场问题描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.siteDesc" disabled type="textarea" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryType" width="130" align="center" label="发运类型"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" align="center" label="售后单号">
        <template slot-scope="scope">
          <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="factoryNo" align="center" label="出厂编号"/>
      <el-table-column prop="csNo" align="center" label="关联售后单号"/>
      <el-table-column prop="backNo" align="center" label="退回单号"/>
      <el-table-column prop="backTime" align="center" label="退回日期"/>
      <el-table-column prop="createTime" align="center" label="创建时间"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editMaintain.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status===10" type="success" @click="handleSubmit(scope.row.pkid)">提交</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <maintains-edit ref="editMaintain" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import MaintainsEdit from "@/views/afterSalesManagement/Maintain/MaintainEdit";
  export default {
    name: "MaintainList",
    components: {MaintainsEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        filter: {
          billNo: "",
          factoryNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      handleSubmit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", `maintains/submit/${pkid}`).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      submitRepair(pkid) {
        this.$confirm("确定提交维修登记吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", `maintains/submitRepairRegistrations/${pkid}`).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      goto(row) {
        this.$router.push({
          path: "/Maintain",
          query: {
            billType: 26,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","maintains",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
